"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Heading = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
var isInverseStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
});
var isTrailingStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  justify-content: space-between;\n"], ["\n  justify-content: space-between;\n"])));
exports.Heading = styled_components_1.default.button(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  width: 100%;\n  height: 3rem;\n  padding: 0 1.5rem;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n  }\n\n  ", "\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  background: none;\n  border: none;\n  width: 100%;\n  height: 3rem;\n  padding: 0 1.5rem;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n  }\n\n  ", "\n  ", "\n"])), isDisabled, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', isInverseStyles);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isTrailing', isTrailingStyles);
});
var templateObject_1, templateObject_2, templateObject_3;